<template>
    <div class="join">
        <home-nav></home-nav>
        <div class="home-carousel" ref="currentWidth">
            <el-carousel
                    :width="carouselWidth + 'px'"
                    height="510px"
                    :autoplay="false"
                    arrow="hover"
            >
                <el-carousel-item v-for="(item,index) in carouselList"
                                  :key="index"
                >
                    <img :src="item.banner_img" @click="toMessage(item.index)" alt="">
                </el-carousel-item>
            </el-carousel>
        </div>
        <div class="joinCompany" id="message">
            <div class="joinCompanyAll">
                <div class="joinCompanyRight">
                    <div class="joinCompanyForm">
                        <p class="normalText">
                            JOIN US RIGHT NOW
                        </p>
                        <p class="boldText">
                            现在填写信息入驻秒通过
                        </p>
                        <p class="boldLine"></p>
                        <div class="joinCompanyBox">
                            <div class="join_applyContent">
                                <div class="join_applyContentTop">
                                    <div class="join_inputCd">
                                        <div class="join_inputContent">
                                            <input v-model="cName" type="text" placeholder="车队名[或个人名字]">
                                        </div>
                                    </div>

                                    <div class="join_inputTel">
                                        <input v-model="userPhone"
                                               type="text"
                                               placeholder="手机号码"

                                               oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                                               maxlength="11"
                                        >
                                    </div>

                                    <div class="join_inputTuijian">
                                        <input v-model="tuijianma" type="text" placeholder="推荐码">
                                    </div>

                                    <!--<div class="join_inputCode">
                                        <div id="slider2" class="slider"></div>
                                    </div>-->

                                    <div class="join_inputCode">
                                        <input v-model="verificationCode" type="text" placeholder="验证码">
                                        <div class="inputVerText" id="getVerify" v-show="!sendSuccess"
                                             @click="getCode()">
                                            获取验证码
                                        </div>
                                        <span class="getCodeTime" v-show="sendSuccess">
                                            发送成功{{ sixten }}s
                                        </span>
                                    </div>
                                </div>
                                <div class="join_applyContentBtn" @click="submitClick()">
                                    提交申请
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="joinCompanyStep">
                        <p class="boldText">
                            加盟步骤
                        </p>
                        <p class="boldLine"></p>
                        <div class="joinStepBox">
                            <ul class="joinStepBoxUl">
                                <li class="joinStepBoxLi">
                                    <img src="@/assets/images/join/process_icon01.png" alt="">
                                    <div class="joinStepBoxLiList">
                                        <div class="joinStepBoxLiBold">
                                            申请入驻（最快1小时）
                                        </div>
                                        <div class="joinStepBoxLiNormal">
                                            填写入驻信息最快<span>1小时</span>即可入驻平台
                                        </div>
                                    </div>
                                </li>
                                <li class="joinStepBoxLi">
                                    <img src="@/assets/images/join/process_icon02.png" alt="">
                                    <div class="joinStepBoxLiList">
                                        <div class="joinStepBoxLiBold">
                                            入驻审核（3~7个工作日）
                                        </div>
                                        <div class="joinStepBoxLiNormal">
                                            我们工作人员24小时在线审核入驻仅需<span>3~7个工作日</span>即可知结果
                                        </div>
                                    </div>
                                </li>
                                <li class="joinStepBoxLi">
                                    <img src="@/assets/images/join/process_icon03.png" alt="">
                                    <div class="joinStepBoxLiList">
                                        <div class="joinStepBoxLiBold">
                                            签订协议
                                        </div>
                                        <div class="joinStepBoxLiNormal">
                                            入驻后签订<span>纸质/电子协议</span>，以便保障双方的利益
                                        </div>
                                    </div>
                                </li>
                                <li class="joinStepBoxLi">
                                    <img src="@/assets/images/join/process_icon04.png" alt="">
                                    <div class="joinStepBoxLiList">
                                        <div class="joinStepBoxLiBold">
                                            开通完成
                                        </div>
                                        <div class="joinStepBoxLiNormal">
                                            开通成功可使用账号进入保时达，开始发布推广信息
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <div class="joinStepBoxRight">
                                <div class="joinStepBoxRightLine"></div>
                                <ul class="joinStepBoxRightUl">
                                    <li class="joinStepBoxRightLi">
                                        1
                                    </li>
                                    <li class="joinStepBoxRightLi">
                                        2
                                    </li>
                                    <li class="joinStepBoxRightLi">
                                        3
                                    </li>
                                    <li class="joinStepBoxRightLi">
                                        4
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="joinCompanyLeft">
                    <div class="joinCompanyLeftContent">
                        <p class="engBox">SEVEN ADVANTAGE</p>
                        <p class="engBoxChina">加盟入驻！即可开始轻松接单！</p>
                        <p class="colorLine"></p>

                        <!--:data="arr"-->
                        <vue-seamless-scroll
                                :data="arr"
                                class="seamless-warp"
                                :class-option="classOption"
                        >
                            <ul class="joinCompanyUl">
                                <li class="scrollLi" v-for="(item,index) in arr" :key="index">
                                    <img class="scrollLiImg" :src="item.img" alt="">
                                    <div class="scrollLiCenter">
                                        <div class="centerName">
                                            {{ item.name }}
                                        </div>
                                        <div class="centerTime">
                                            {{ item.content }}
                                        </div>
                                    </div>
                                    <div class="scrollBtn">
                                        接单
                                    </div>
                                </li>
                            </ul>
                        </vue-seamless-scroll>

                        <div class="moreJoin">
                            <p class="moreJoinBold">
                                点击了解更多入驻相关内容：
                            </p>
                            <ul class="moreJoinUl">
                                <li class="moreJoinLi">
                                    <span class="moreJoinLiCircle"></span>
                                    入驻须知
                                </li>
                                <li class="moreJoinLi">
                                    <span class="moreJoinLiCircle"></span>
                                    入驻指南
                                </li>
                                <li class="moreJoinLi" @click="toAbout()">
                                    <span class="moreJoinLiCircle"></span>
                                    联系我们
                                </li>
                            </ul>
                            <img class="moreJoinImg" src="@/assets/images/join/driver_img_moreBg.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <home-footer></home-footer>


        <!--弹窗展示-->
        <div class="tc_mask" v-show="sureInfo"></div>
        <div class="showContent" v-show="sureInfo">
            <img class="fixedImg" src="@/assets/images/join/img_bg_join.png" alt="">
            <div class="showList">
                <img class="showClose" src="@/assets/images/join/icon_close_tc.png" alt="" @click="closeTan()">
                <p class="showListTitle">加盟申请</p>
                <div class="showListItem">
                    <span class="itemText">车&nbsp;&nbsp;队&nbsp;&nbsp;名：</span>
                    <p class="itemContent tCname">{{ cName }}</p>
                </div>
                <div class="showListItem">
                    <span class="itemText">手机号码：</span>
                    <p class="itemContent tPhone">{{ userPhone }}</p>
                </div>
                <div class="showListItem">
                    <span class="itemText">推荐码：</span>
                    <p class="itemContent tuijian">{{ tuijianma }}</p>
                </div>
                <div class="showBtnList">
                    <div class="showBtnLeft" @click="sureBtn()">确认提交</div>
                    <div class="showBtnBack" @click="closeTan()">返回修改</div>
                </div>
                <p class="showListBottom">
                    注：车队名，所属城市一旦提交无法修改，请确认信息无误后提交，修改请返回修改
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    import HomeNav from '@/components/homeNav';
    import HomeFooter from '@/components/homeFooter';
    import vueSeamlessScroll from 'vue-seamless-scroll'

    export default {
        name: "join",
        components: {
            HomeNav,
            HomeFooter,
            vueSeamlessScroll
        },
        data() {
            return {
                carouselWidth: '',
                carouselList: [
                    {
                        banner_img: require('@/assets/images/join/driver_img_banner.png'),
                    }
                ],
                arr: [
                    {
                        img: require('@/assets/images/join/home_pic_headPor.png'),
                        name: '黄女士（158****1215）',
                        content: '06:09:42 下单；厦门包车；10人',
                    },
                    {
                        img: require('@/assets/images/join/01.png'),
                        name: '郑先生（138****1596）',
                        content: '7:10:11 下单；深圳包车；25人',
                    },
                    {
                        img: require('@/assets/images/join/02.png'),
                        name: '姚女士（188****0369）',
                        content: '08:12:49 下单；上海包车；16人',
                    },
                    {
                        img: require('@/assets/images/join/03.png'),
                        name: '康女士（136****0225）',
                        content: '09:09:03 下单；广州包车；18人',
                    },
                    {
                        img: require('@/assets/images/join/04.png'),
                        name: '江先生（183****4027）',
                        content: '10:11:06 下单；南昌包车；50人',
                    },
                    {
                        img: require('@/assets/images/join/05.png'),
                        name: '周女士（139****5425）',
                        content: '11:10:01 下单；漳州包车；9人',
                    },
                    {
                        img: require('@/assets/images/join/06.png'),
                        name: '谢先生（133****8056）',
                        content: '11:22:25 下单；杭州包车；25人',
                    },
                    {
                        img: require('@/assets/images/join/07.png'),
                        name: '阳女士（138****3625）',
                        content: '17:09:42 下单；北京包车；29人',
                    },

                    {
                        img: require('@/assets/images/join/02.png'),
                        name: '周女士（139****5425）',
                        content: '11:10:01 下单；漳州包车；9人',
                    },
                    {
                        img: require('@/assets/images/join/05.png'),
                        name: '谢先生（133****8056）',
                        content: '11:22:25 下单；杭州包车；25人',
                    },
                    {
                        img: require('@/assets/images/join/07.png'),
                        name: '阳女士（138****3625）',
                        content: '17:09:42 下单；北京包车；29人',
                    },
                ],
                /*joinList: [
                    {
                        img: require('@/assets/images/join/advantage_icon01.png'),
                        text: '资源丰富',
                        content: '车队资源丰富，天天有单，旺季有车，淡季有单。'
                    },
                    {
                        img: require('@/assets/images/join/advantage_icon02.png'),
                        text: '客户流量',
                        content: '一经推广，免费广告，为您全网引流。'
                    },
                    {
                        img: require('@/assets/images/join/advantage_icon03.png'),
                        text: '售后服务',
                        content: '专属客服，24小时在线为您及时处理突发问题。'
                    },
                    {
                        img: require('@/assets/images/join/advantage_icon04.png'),
                        text: '车队主页',
                        content: '入驻后平台免费赠送3次帮您优化车队主页的服务。'
                    },
                    {
                        img: require('@/assets/images/join/advantage_icon05.png'),
                        text: '推广方式',
                        content: '多种推广方式，让您的车队自由选择推广路径。'
                    },
                    {
                        img: require('@/assets/images/join/advantage_icon06.png'),
                        text: '免费入驻',
                        content: '入驻不收费，简化您的入驻步骤，让您随时上版。'
                    },
                    {
                        img: require('@/assets/images/join/advantage_icon07.png'),
                        text: '透明接单',
                        content: '车队与客户直接对话接单，无中间商赚差价。'
                    }
                ]*/

                cName: '',
                userPhone: '',
                tuijianma: '',
                verificationCode: '',
                sixten: 60, //60秒倒计时
                sendSuccess: false, //短信是否发送成功
                sureInfo: false,
            }
        },
        // 根据屏幕自适应轮播图大小
        mounted() {
            window.scrollTo(0, 0);
            this.carouselWidth = this.$refs.currentWidth.clientWidth;
        },
        methods: {
            toAbout(){
                this.$router.push({path: '/about'});
            },
            toMessage(){
                this.$el.querySelector(`#message`).scrollIntoView({
                    behavior: "smooth",  // 平滑过渡
                    block: "start"  // 上边框与视窗顶部平齐。默认值
                });
            },
            //提交申请
            submitClick() {
                var that = this;
                var Cname = that.cName;
                var phone = that.userPhone;
                var tuijianma = that.tuijianma;
                var verificationCode = that.verificationCode;

                if (Cname.trim().length < 1 || Cname.length > 20) {
                    // layer.msg('请填写正确的车队名', {icon: 2});
                    this.$message('请填写正确的车队名');
                    return;
                }
                var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                if (!myreg.test(phone)) {
                    // layer.msg('请填写正确的手机号码！', {icon: 2});
                    this.$message('请填写正确的手机号码');
                    return;
                }
                if (verificationCode.length < 1) {
                    // layer.msg('请填写验证码', {icon: 2});
                    this.$message('请填写验证码');
                    return;
                }
                that.sureInfo = true;
            },

            closeTan() {
                this.sureInfo = false;
            },

            sureBtn() {
                var that = this;
                var company_name = that.cName;
                var phone = that.userPhone;
                var tuijianma = that.tuijianma;
                var verifyCode = that.verificationCode;

                var index;
                /*layui.use('layer', function () {
                    var layer = layui.layer;
                    index = layer.load(1, {
                        shade: [0.1, '#fff'] //0.1透明度的白色背景
                    });
                });*/
                that.$axios.post('http://api.baostart.com/api/ApplicationAdmission', {
                    company_name: company_name,
                    phone: phone,
                    verifyCode: verifyCode,
                    invite_code: tuijianma,
                    is_pc: 1
                }).then((res) => {
                    // layer.close(index);
                    res = res.data;
                    // console.log(res);
                    if (res.status == 200) {
                        that.cName = '';
                        that.userPhone = '';
                        that.tuijianma = '';
                        /*layer.msg(res.message, {icon: 1, time: 1500}, function () {
                            // window.open('http://vvv.baostart.com/Business/index');
                            window.open('http://dt.hbc1223.com/');
                        });*/
                        window.open('http://dt.hbc1223.com/');
                    } else {
                        // layer.msg(res.message, {icon: 2});
                        this.$message(res.message);
                    }
                }).catch((error) => {
                    // layer.close(index)
                    console.log(error);
                });
            },

            /*发送验证码时，开始计数，一分钟发送一次*/
            getCode() {
                var that = this;
                var phone = that.userPhone; //手机号码
                var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                if (!myreg.test(phone)) {
                    /*layer.msg('请输入正确的手机号码！', {
                        icon: 2
                    });*/
                    this.$message('请输入正确的手机号码！');
                    return;
                }
                var index;
                /*layui.use('layer', function () {
                    var layer = layui.layer;
                    index = layer.load(1, {
                        shade: [0.1, '#fff'] //0.1透明度的白色背景
                    });
                });*/
                that.$axios.post("http://api.baostart.com/api/getVerfyCode", {
                    phone: phone,
                    use_type: 2,
                }).then((res) => {
                    res = res.data;
                    if (res.status == 200) {
                        // layer.closeAll();
                        // layer.msg(res.message);
                        this.$message(res.message);
                        that.sendSuccess = true;
                        //倒计时
                        that.time_down();
                    } else {
                        // layer.closeAll();
                        // layer.msg(res.message, {icon: 2});
                        this.$message(res.message);
                    }
                }).catch((error) => {
                    // layer.closeAll();
                    // layer.msg('系统错误', {
                    //     icon: 2
                    // });
                    this.$message('系统错误');
                });
            },

            //倒计时注册
            time_down() {
                var that = this;
                //记录点击时间
                var t1 = window.setInterval(function () {
                    var num = that.sixten;
                    num = num - 1;
                    if (num < 1) {
                        that.sendSuccess = false;
                        window.clearInterval(t1);
                        that.sixten = 60;
                    } else {
                        that.sixten = num;
                    }
                }, 1000);
            },
        },
        computed: {
            classOption() {
                return {
                    step: 1, // 数值越大速度滚动越快
                    limitMoveNum: 1, // 开始无缝滚动的数据量 this.dataList.length
                    hoverStop: true, // 是否开启鼠标悬停stop
                    direction: 1, // 0向下 1向上 2向左 3向右
                    openWatch: true, // 开启数据实时监控刷新dom
                    singleHeight: 90, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
                    singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
                    waitTime: 0 // 单步运动停止的时间(默认值1000ms)
                }
            }
        }
    }
</script>

<style scoped>
    @import './join.css';
</style>



// WEBPACK FOOTER //
// src/pages/join/join.vue